import React from "react";
import PropTypes from "prop-types";

import "./Dialog.css";

export default class Dialog extends React.Component {

  static propTypes = {
    fitScreen: PropTypes.bool
  }

  static defaultProps = {
    fitScreen: false
  }

  render() {
    const classNames = ["dialog"];
    this.props.fitScreen ? classNames.push("dialog-screen") : classNames.push("dialog-frame");

    return (
      <div className={classNames.join(" ")}>
        { this.props.children }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Dialog.js